import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config'
import { urlResolverGetFaq } from '../../url-handling'

import {
  type ContactPageFaqCard,
  ContactPageFaqCardsSectionCard,
} from './ContactPageFaqCardsSectionCard'

export const ContactPageFaqCardsSection: FC<{
  cards: ContactPageFaqCard[]
}> = ({ cards }) => {
  const config = useGlobalConfigContext()

  return (
    <div className="bg-light-primary-low px-4 py-9 tablet:py-12 tablet:text-center">
      <h2 className="mb-4 text-2xl font-medium">
        <FormattedMessage id="contact.faqCardsSection.title" />
      </h2>
      <p className="mb-4 text-l text-dark-primary-strong tablet:mb-12">
        <FormattedMessage id="contact.faqCardsSection.description" />
      </p>

      <div className="grid w-full grid-cols-1 gap-4 tablet:container tablet:grid-cols-3 tablet:grid-rows-2 tablet:gap-y-12">
        {cards.map((card) => (
          <ContactPageFaqCardsSectionCard
            description={card.description}
            href={card.href}
            key={card.title}
            title={card.title}
          />
        ))}
      </div>

      <Button<'a'>
        className="mt-4 w-full tablet:mt-12 tablet:w-auto"
        color="secondary"
        href={urlResolverGetFaq(config)}
        id="contact-faq-go-to-faq-page"
        slots={{ root: 'a' }}
        variant="outlined"
      >
        <FormattedMessage id="contact.faqSection.faqCard.cta.label" />
      </Button>
    </div>
  )
}
